import { findFlagUrlByIso3Code } from 'country-flags-svg/dist';

class HomePageView {
  #buttonLearn = document.querySelector('.learn-button');
  #rankListEl = document.querySelector('.rank-list');
  #countdownSpanEl = document.querySelector('.countdown-span');

  renderWelcomeMessage(data) {
    const containerEl = document.querySelector('.welcome-container');
    const markup = `<h1>Welcome back, ${data.username}</h1>`;
    console.log(markup);
    console.log(containerEl);
    containerEl.insertAdjacentHTML('afterbegin', markup);
  }

  renderRank(rank) {
    console.log(rank);
    rank.forEach((userData) => {
      console.log(findFlagUrlByIso3Code(userData.country));
      const markup = `<li>
                  <div class="person">
                    <p class="position">${userData.position}</p>
                    <!--
                    <object
                      type="image/svg+xml"
                      data="${findFlagUrlByIso3Code(userData.country)}"
                      class=""
                    >
                      Your browser does not support SVG
                    </object>
                    -->
                    <p class="name">${userData.userName}</p>
                    <p class="exp">${userData.points} xp</p>
                  </div>
                </li>`;

      this.#rankListEl.insertAdjacentHTML('beforeend', markup);
    });
    console.log(this.#rankListEl);
  }

  renderUserRank(userRank) {
    const markup = `<div class="dots">
    <button class="dot" id="dot-2"></button>
    <button class="dot" id="dot-2"></button>
    <button class="dot" id="dot-2"></button>
    </div><li class="user"> 
      <div class="person">
        <p class="position">${userRank.position ? userRank.position : '-'}</p>
        <!--
        <object
          type="image/svg+xml"
          data="${findFlagUrlByIso3Code(userRank.country)}"
          class=""
        >
          Your browser does not support SVG
        </object>
        -->
        <p class="name">${userRank.userName}</p>
        <p class="exp">${userRank.points} xp</p>
      </div>
    </li>`;
    this.#rankListEl.insertAdjacentHTML('beforeend', markup);
  }

  colorUserRankBackground(position) {
    console.log(
      this.#rankListEl
        .querySelectorAll('li')
        [position - 1].classList.add('user')
    );
  }

  addButtonLearnEvent() {
    console.log(this.#buttonLearn);
    console.log(this);
    this.#buttonLearn.addEventListener('click', () => {
      window.location.href = '../../questions.html';
    });
  }

  setCountdown() {
    this.#renderCountdown();
    setInterval(this.#renderCountdown.bind(this), 1000);
  }

  #renderCountdown() {
    let time = this.#calculateTime();
    this.#countdownSpanEl.innerText = time;
  }

  #calculateTime() {
    let d = new Date();
    let hours = 23 - d.getUTCHours();
    let min = 59 - d.getMinutes();
    if ((min + '').length == 1) {
      min = '0' + min;
    }
    let sec = 59 - d.getSeconds();
    if ((sec + '').length == 1) {
      sec = '0' + sec;
    }
    return hours + ':' + min + ':' + sec;
  }
}

export default new HomePageView();
